<template>
  <!-- Fullwidth Shop Area -->
  <div class="shop-area bg-white section-padding-bottom-md">
    <div class="container">

      <!-- Shop Breadcrumb -->
      <breadcrumb></breadcrumb>
      <!--// Shop Breadcrumb -->

      <!-- Shop Page Toolbars -->
      <page-toolbars cls="shop-page-toolbars"  :total-page="page.totalPage" :page-num="page.pageNum"></page-toolbars>
      <!--// Shop Page Toolbars -->

      <!-- Shop Page Products -->
      <div class="row justify-content-left shop-page-products products-wrapper">

        <!-- Single Product -->
        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12" v-for="product in productList">
          <div class="product-item">

            <div class="product-item-images">
              <router-link :title="product.name" :to="{ name: 'product-detail', params: { path:$route.params.path,id:product.productSn}}"  class="product-item-image-inner">
                 <img :src="product.pic" :alt="product.name" style="width: 100%;height: auto;">
              </router-link>
              <router-link  :title="product.name" :to="{ name: 'product-detail', params: { path:$route.params.path,id:product.productSn}}"  class="add-to-cart-button">
                <span>VIEW</span>
              </router-link>
            </div>

            <div class="product-item-content">
              <div class="product-item-content-left">
                <h5><router-link :title="product.name" :to="{ name: 'product-detail', params: { path:product.productCategoryName,id:product.productSn}}">{{product.name}}</router-link></h5>
               <!-- <div class="price-box">
                  <span class="pricebox-price">${{product.price}}</span>
                </div>-->
              </div>
              <p>{{product.description}}</p>

            </div>

          </div>
        </div>
        <!--// Single Product -->
      </div>
      <!-- Shop Page Toolbars -->
      <page-toolbars cls="shop-page-toolbars shop-page-toolbars-bottom" :total-page="page.totalPage" :page-num="page.pageNum"></page-toolbars>
      <!--// Shop Page Toolbars -->
    </div>
  </div>
        <!--// Fullwidth Shop Area -->
</template>

<script>
  import request from '@/utils/request'
  import widgets from './widgets'
  import pageToolbars from './page-toolbars'
  import breadcrumb from '@/components/breadcrumb'
  import {setDocument} from '@/utils/documentSEO'
  export default {
    name: "product-index",
    components:{
      widgets,pageToolbars,breadcrumb
    },
    data(){
      return {
        productList:[],
        page:{
          totalPage:1,
          pageNum:1
        }
      }
    },
    watch:{
      '$route.path':function(newVal,oldVal){
        //this.loadPathProduct(newVal)
      },
      '$route':function(newVal,oldVal){
        this.loadPathProduct(newVal.path,newVal.query.pageNum || 1)
      },
    },
    methods:{
      loadPathProduct(path,pageNum){
        const  _this = this
        let reg = new RegExp("large-size","g");
        request({
          url: path+'/list-page',
          method: 'GET',
          params:{pageNum: pageNum, pageSize: 16,mainMaterial:_this.$route.query.mainMaterial||'',keyword:_this.$route.query.keyword||'',verifyStatus:1}
        }).then(res=>{
          if(res.data.code===200){
            _this.productList= res.data.data.list
            _this.productList.forEach((item,index)=>{
                item.pic =item.pic.replace(reg,'thumbnail-size')
            })
            _this.page.totalPage = res.data.data.totalPage
            _this.page.pageNum = res.data.data.pageNum
          }
        })

        request({
          url:'/productCategory/item',
          method:'GET',
          params:{path:this.$route.params.path||''}
        }).then(res=>{
          if(res.data.code===200){
            _this.detailData = res.data.data
            setDocument(_this.detailData.productUnit,_this.detailData.keywords,_this.detailData.description)
          }
        })
      }
    },
    created(){
      $('select').niceSelect()
      this.loadPathProduct(this.$route.path,this.$route.query.pageNum || 1)
    }

  }
</script>

<style scoped>

</style>
